import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  popup: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 16,
    boxShadow: '0px 10px 40px rgba(219, 130, 130, 0.5)',
    padding: 24,
    width: '100%',
    zIndex: 10,
    display: 'none',
    margin: '40px 0',

    '&$error, &$warning': {
      display: 'grid',
      gridTemplateColumns: '48px 1fr',
      columnGap: 16,
      padding: 16,
      marginTop: 24,

      alignItems: 'center',
    },
    '&$warning': {
      backgroundColor: '#f99245',
    },
    '&$error': {
      backgroundColor: theme.palette.error.main,
    },
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: theme.palette.background.default,
    color: theme.palette.primary.dark,

    '&$border': {
      borderWidth: 3,
      borderColor: theme.palette.primary.dark,
      borderStyle: 'solid',
    },

    '& i': {
      fontSize: 24,
    },

    '&$error, &$warning': {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.error.main,
      alignSelf: 'flex-start',
    },
    '&$warning': {
      color: '#f99245',
    },
    '&$error': {
      color: theme.palette.error.main,
    },
  },
  error: {
    /* nesting */
  },
  warning: {
    /* nesting */
  },
  title: {
    color: theme.palette.background.default,
    margin: '16px 0 8px',
  },
  description: {
    color: theme.palette.background.default,
  },
  button: {
    width: 92,
    height: 40,
    backgroundColor: theme.palette.background.default,
    borderRadius: 8,
    color: theme.palette.secondary.dark,
    padding: 0,
    boxShadow: 'none',
    marginTop: 16,
  },
  showPopup: {
    display: 'block',
  },
  openPopupBtn: {
    display: 'block',
    margin: '20px auto',
  },
  staticPopup: {
    display: 'block',
    margin: 0,
    maxWidth: 'initial',
  },
  disableBoxShadow: {
    boxShadow: 'none',
  },
  border: {
    /* nesting */
  },
  [theme.breakpoints.up('sm')]: {
    popup: { maxWidth: 350 },
    fixedPopup: {
      transform: 'translateY(-100vh)',
      transition: 'transform 0.5s',
      transitionDelay: '0s',
      display: 'block',
      order: 1,
      alignSelf: 'flex-start',
      marginTop: 210,
    },
    showFixedPopup: {
      marginTop: 'calc(50vh - var(--header-height))',
      transform: 'translateY(-50%)',
      transitionDelay: '0.5s',
    },
    disableOnTabled: {
      display: 'none',
    },
    staticPopup: {
      maxWidth: 'initial',
    },
  },
  [theme.breakpoints.up('md')]: {
    popup: {
      transform: 'translateY(-150vh)',
      transition: 'transform 0.5s, margin-top 0.5s',
      transitionDelay: '0s',
      display: 'block',
      order: 1,
      alignSelf: 'flex-start',
    },
    showPopup: {
      marginTop: 'calc(50vh - var(--header-height) - 8px)',
      transform: 'translateY(-50%)',
      transitionDelay: '0.5s',
    },
    openPopupBtn: { display: 'none' },
    staticPopup: { transform: 'none' },
  },
}));

export default useStyles;
